import type { RouteLocationRaw } from "#vue-router";
import type {
  CategoryPageListApiFilters,
  CategoryPageListApiView,
} from "~~/model/category.model";

export type CategoryPageListView = CategoryPageListApiView & {
  _links: {
    page: RouteLocationRaw;
  };
};
export function useCategoryPageList(filters?: CategoryPageListApiFilters) {
  return useLazyFetch("/api/category-pages", {
    query: filters,
    dedupe: "defer",
    default: () => [],
    transform(data) {
      return data.map((categoryPage) => {
        const view: CategoryPageListView = {
          ...categoryPage,
          _links: {
            page: {
              name: "formations-slug",
              params: {
                slug: categoryPage.slug,
              },
            },
          },
        };

        return view;
      });
    },
  });
}
